<template>
 <div class="">
   <div class="formBox margbot" ref="searchBox">
      <el-form :inline="true" class="demo-form-inline" label-width="100px" size="mini">
        <div class="formItemBox">
        <el-form-item label="年月:">
          <el-date-picker
            v-model="searchFrom.yearMonth"
            type="month"
            format="yyyy-MM"
            value-format="yyyy-MM"
            :clearable="false"
            placeholder="请选择">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="审核状态:" >
          <el-select v-model="searchFrom.auditStatus"  placeholder="请选择">
            <el-option label="全部" value="" ></el-option>
            <el-option label="待审核" value="待审核" ></el-option>
            <el-option label="审核中" value="审核中" ></el-option>
            <el-option label="已通过" value="已通过" ></el-option>
            <el-option label="已驳回" value="已驳回" ></el-option>
            <el-option label="不审核" value="不审核" ></el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item label="所属小队:" >
          <el-select v-model="searchFrom.teamId" filterable placeholder="请选择" clearable @change="xiaoduiChange">
            <el-option v-for="item in XDList" :label="item.name" :value="item.id" :key="item.id"></el-option>
          </el-select>
        </el-form-item> -->
        <!-- <el-form-item label="车辆号牌:">
          <el-select v-model="searchFrom.plateNumber" filterable placeholder="请选择">
            <el-option v-for="item in carList" :label="item.vhcNo" :value="item.vhcNo" :key="item.id"></el-option>
          </el-select>
        </el-form-item> -->
        </div>
        <div style="display: flex;align-items: center;padding-right: 20px;">
          <div class="searchBtnBox" style="flex-shrink:0">
            <el-button type="primary" size="mini" @click="searchFn" v-if="btnFlg[0]">查询</el-button>
            <el-button type="primary" size="mini" @click="resetForm('searchFrom')">重置</el-button>
            <!-- <el-button type="primary" @click="exportFn" size="mini" :disabled="isDisable" v-if="btnFlg[1]">导出</el-button> -->
            <el-button type="primary" size="mini" @click="shengChengFn('searchFrom')" v-if="btnFlg[2]">生成</el-button>
          </div>
        </div>
      </el-form>
    </div>
    <!--  表格 -->
    <div class="table" :style="{height:h}">
      <el-table :data="tableList" ref="table" v-loading="loading" bordersize="mini" style="width: 100%" height="100%"  center border class="tableComent">
        <el-table-column type="index" width="55" label="序号"></el-table-column>
        <el-table-column width="130" label="操作">
          <template slot-scope="scope">
            <div>
              <el-button v-if="(scope.row.auditStatus=='待审核' || scope.row.auditStatus=='已驳回' || scope.row.auditStatus=='不审核') && btnFlg[3]" type="text" size="mini" @click="gengxinFn(scope.row)">更新</el-button>
              <el-button v-if="(scope.row.auditStatus=='待审核' || scope.row.auditStatus=='已驳回') && btnFlg[4]" type="text" size="mini" @click="delFn(scope.row)">删除</el-button>
              <el-button type="text" size="mini" @click="shenHeFn(scope.row)" v-if="scope.row.auditStatus == '待审核' && btnFlg[5]">审核</el-button>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="auditStatus" label="审核状态" min-width="130">
          <template slot-scope="scope">
            <div>
              <span v-if="scope.row.auditStatus=='待审核'" style="color: #E6A23C;">{{scope.row.auditStatus}}</span>
              <span v-if="scope.row.auditStatus=='审核中'" style="color: #E99D42;" >{{scope.row.auditStatus}}</span>
              <span v-if="scope.row.auditStatus=='已通过'" style="color: #67C23A">{{scope.row.auditStatus}}</span>
              <span v-if="scope.row.auditStatus=='已驳回'" style="color: #F56C6C">{{scope.row.auditStatus}}</span>
              <span v-if="scope.row.auditStatus=='不审核'">{{scope.row.auditStatus}}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="dataYearMonth" label="年月" min-width="100">
          <template slot-scope="scope">
            <div>
              <el-button type="text" size="mini" @click="detailFn(scope.row)">{{ scope.row.dataYearMonth }}</el-button>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="vehicleCount" label="车数" min-width="100"></el-table-column>
        <el-table-column prop="signedWayCount" label="签收单数" min-width="100"></el-table-column>
        <el-table-column prop="totalMileage" label="行驶里程(KM)" min-width="130"></el-table-column>
        <el-table-column prop="totalIncome" label="累计收入(元)" min-width="130">
          <template slot-scope="scope">
            <span style="color: #67C23A;">{{scope.row.totalIncome}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="totalExpense" label="累计支出(元)" min-width="130">
          <template slot-scope="scope">
            <span style="color: #F56C6C;">{{scope.row.totalExpense}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="profit" label="毛利(元)" min-width="130"></el-table-column>
        <el-table-column prop="profitMargin" label="毛利率(%)" min-width="110"></el-table-column>
        <el-table-column prop="createUser" label="创建人" min-width="130"></el-table-column>
        <el-table-column prop="createTime" label="创建时间" width="170" :formatter="dateTimeFormat"></el-table-column>
        <el-table-column prop="auditUserName" label="审核人" min-width="130" :formatter="emptyFn"></el-table-column>
        <el-table-column prop="auditTime" label="审核时间" width="170" :formatter="dateTimeFormat"></el-table-column>
        <el-table-column prop="auditRemark" label="审核意见" min-width="130" :formatter="emptyFn" show-overflow-tooltip></el-table-column>
      </el-table>
    </div>
     <!-- 分页 -->
    <div>
      <el-pagination background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="searchFrom.pageNo"
        :page-sizes="[50,100,200,500]"
        :page-size="searchFrom.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
    <!-- 新增资金计划周期 -->
    <el-dialog title="生成" :close-on-click-modal="false" :close-on-press-escape="false" :visible.sync="dialogVisible" @close="closeSC" center width="500px">
      <el-form :rules="rules" :model="addForm" :validate-on-rule-change="false" ref="addForm" class="demo-form-inline" label-width="150px" :inline="false" size="small" v-if="dialogVisible">
        <div class="addinpBox">
          <el-form-item label="年月:" prop="dataYearMonth">
            <el-date-picker
              v-model="addForm.dataYearMonth"
              format="yyyy-MM"
              value-format="yyyy-MM"
              type="month"
              :picker-options="pickerOptions"
              placeholder="请选择">
            </el-date-picker>
          </el-form-item>
        </div>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" size="mini" @click="saveFn" :loading="addLoading">保 存</el-button>
        <el-button @click="closeSC" size="mini">取 消</el-button>
      </span>
    </el-dialog>
    <!-- 审核 -->
    <el-dialog title="审核" :close-on-click-modal="false" :close-on-press-escape="false" @close="shFlag = false"  :visible.sync="shFlag" width="400px" center>
      <div>
        <el-form :inline="true" :rules="rules" ref="shForm" :model="shForm" class="demo-form-inline jiaoyan"  label-width="100px" size="mini">
          <el-form-item label="审核状态:" prop="auditResult">
            <template >
              <el-radio-group v-model="shForm.auditResult"  >
                <el-radio label="pass">通过</el-radio>
                <el-radio label="reject">驳回</el-radio>
              </el-radio-group>
            </template>
          </el-form-item>
          <el-form-item label="驳回原因:" class="item1" prop="remark" v-if="shForm.auditResult=='reject'">
            <el-input placeholder="" type="textarea" maxlength="100" v-model="shForm.remark" class="gjh"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="shFlag = false">取 消</el-button>
        <el-button type="primary" @click="SHFn()">确 定</el-button>
      </span>
    </el-dialog>
 </div>
</template>

<script>
import { getBtn } from '@/utils/getButton'
import { formatterRowEmpty, dateTimeFormat, dateFormat, emptyFn } from '@/utils/util'
import { exportExcel } from '@/utils/fileDownXlsx.js'
import { tVehicleAccountingList, tVehicleAccountingGenerate, tVehicleAccountingUpdate, tVehicleAccountingDelete, tVehicleAccountingAudit } from '@/api/newTMS'
import { organizationTree, cVIlists } from '@/api/vgs-driver2.0'
export default {
  components: {
  },
  data () {
    return {
      emptyFn: emptyFn,
      h: 500,
      dateTimeFormat: dateTimeFormat,
      dateFormat: dateFormat,
      formatterRowEmpty: formatterRowEmpty,
      tableList: [],
      searchFrom: {
        pageNo: 1,
        pageSize: 50
      },
      total: 0,
      loading: false,
      isDisable: false,
      sum: {},
      XDList: [],
      carList: [],
      btnFlg: [],
      btnIdArr: ['01N02A0100', '01N02A0200', '01N02A0300', '01N02A0400', '01N02A0500', '01N02A0600'],
      dialogVisible: false,
      addForm: {},
      addLoading: false,
      rules: {
        dataYearMonth: [
          { required: true, message: '请选择年月', trigger: 'change' }
        ],
        auditResult: [
          { required: true, message: '请选择审核状态', trigger: 'blur' }
        ],
        remark: [
          { required: true, message: '请输入驳回原因', trigger: 'blur' }
        ]
      },
      pickerOptions: {
        disabledDate (time) {
          const now = new Date()
          const currentYear = now.getFullYear()
          const currentMonth = now.getMonth()

          const selectYear = time.getFullYear()
          const selectMonth = time.getMonth()

          if (selectYear > currentYear) {
            return true
          }
          if (selectYear === currentYear && selectMonth > currentMonth) {
            return true
          }
          return false
        }
      },
      shFlag: false,
      shForm: {}
    }
  },
  created () {
    this.btnFlg = getBtn(this.btnIdArr)
    // this.yearMonthDate = this.getNextMonth()
    this.searchFn()
    organizationTree({ flag: 1 }).then((res) => {
      if (res[0].orgType == 1) {
        this.XDList = res[0].children
      } else {
        this.XDList = res
      }
    })
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = (pH - h - 205) + 'px'
  },
  methods: {
    getNextMonth () {
      const date = new Date()
      date.setMonth(date.getMonth() - 1)

      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')

      return `${year}-${month}`
    },
    // 获取列表
    getList () {
      this.loading = true
      // let strMonth = this.yearMonthDate.split('-')
      // this.$set(this.searchFrom, 'year', Number(strMonth[0]))
      // this.$set(this.searchFrom, 'month', Number(strMonth[1]))
      tVehicleAccountingList(this.searchFrom).then(res => {
        this.tableList = res.list
        this.total = res.total
        this.sum = res.map
        this.loading = false
      })
    },
    carChange (e) {
      if (e) {
      }
    },
    xiaoduiChange (e) {
      if (e) {
        let json = this.XDList.filter(item => item.id == e)
        this.carList = []
        this.$set(this.searchFrom, 'plateNumber', '')
        cVIlists({ vhcClassify: 2, trailerFlag: 0, teamOrgId: json[0].id }).then(res => {
          this.carList = res
        })
      }
    },
    // 导出
    exportFn () {
      let form = { ...this.searchFrom }
      delete form.pageNo
      delete form.pageSize
      exportExcel(
        this.global.tmsPlus + '/vehicleAccounting/vehicleAccountExport',
        form,
        '单车核算列表'
      )
      this.isDisable = true
      setTimeout(() => {
        this.isDisable = false // 点击一次时隔两秒后才能再次点击
      }, 2000)
    },
    // 查选
    searchFn () {
      this.getList(this.searchFrom)
    },
    // 每页条数
    handleSizeChange (val) {
      this.searchFrom.pageSize = val
      this.getList(this.searchFrom)
    },
    // 当前页
    handleCurrentChange (val) {
      this.searchFrom.pageNo = val
      this.getList(this.searchFrom)
    },
    // 重置
    resetForm (formName) {
      this.searchFrom = {
        pageNo: 1,
        pageSize: 50
      }
      // this.yearMonthDate = this.getNextMonth()
      this.searchFn()
    },
    closeSC () {
      this.dialogVisible = false
      this.initAddForm()
    },
    initAddForm () {
      this.addForm = {}
    },
    shengChengFn () {
      this.dialogVisible = true
    },
    saveFn () {
      this.$refs.addForm.validate(valid => {
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: '正在处理...'
          })
          tVehicleAccountingGenerate(this.addForm)
            .then(res => {
              console.log(res)
              loading.close()
              this.dialogVisible = false
              this.getList(this.searchFrom)
              this.initAddForm()
              this.$message.success('生成成功')
            })
            .catch(err => {
              this.addLoading = false
              console.log(err)
              this.$message({
                showClose: true,
                message: err.message,
                type: 'error',
                onClose () {
                  loading.close()
                }
              })
            })
        } else {
          this.addLoading = false
        }
      })
    },
    gengxinFn (row) {
      this.$confirm('是否执行更新操作?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const loading = this.$loading({
          lock: true,
          text: '正在处理...'
        })
        tVehicleAccountingUpdate({
          masterId: row.id
        }).then(res => {
          loading.close()
          this.getList(this.searchFrom)
        }).catch(error => {
          this.$message({
            showClose: true,
            message: error.message,
            type: 'error',
            onClose () {
              loading.close()
            }
          })
        })
      }).catch(() => {

      })
    },
    delFn (row) {
      this.$confirm('是否执行删除操作?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const loading = this.$loading({
          lock: true,
          text: '正在处理...'
        })
        tVehicleAccountingDelete({
          masterId: row.id
        }).then(res => {
          loading.close()
          this.getList(this.searchFrom)
        }).catch(error => {
          this.$message({
            showClose: true,
            message: error.message,
            type: 'error',
            onClose () {
              loading.close()
            }
          })
        })
      }).catch(() => {

      })
    },
    detailFn (row) {
      // 向父组件发送跳转事件，并传递当前行的id
      this.$emit('switchToDetails', {
        id: row.id,
        yearMonth: row.dataYearMonth || this.searchFrom.yearMonth
      })
    },
    // 审核
    shenHeFn (row) {
      this.shFlag = true
      this.$set(this.shForm, 'masterId', row.id)
    },
    SHFn () {
      this.$refs.shForm.validate((valid) => {
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: '正在处理...'
          })
          tVehicleAccountingAudit(this.shForm).then(res => {
            loading.close()
            this.shFlag = false
            this.$message({
              message: '操作成功',
              type: 'success'
            })
            this.getList(this.searchFrom)
          }).catch(error => {
            this.$message({
              showClose: true,
              message: error.message,
              type: 'error',
              onClose () {
                loading.close()
              }
            })
          })
        }
      })
    }
  }
}
</script>

<style scoped lang='less'>
.searchBtnBox{
  margin: 10px 0;
}
.inpBox .el-date-editor{
  width:430px!important;
}
/deep/.el-form{
  width: 100%;
}
.imgBox{
  margin:0;
}

.inpBox .dzBox  /deep/.el-input__inner {
    width: 170px;
}
.imgBox{
  /deep/.el-image{
    width: 180px;
    height: 130px;
    margin-right: 20px;
  }
}
.remark  /deep/.el-input .el-input__inner {
    width: 480px;
    height: 80px;
}
.tongjiBox{
   /deep/.el-form-item--mini .el-form-item__content,  /deep/.el-form-item--mini .el-form-item__label{
        line-height: 20px;
  }
}
.width2  /deep/.el-input .el-input__inner {
    width: 480px;
}
.formItemBox{
  /deep/.el-form-item{
    width: 24%;
  }
}
</style>
